// App
import React from 'react';

// Misc / utils
import * as S from './styles';

type FaqQuestion = {
  question: string;
  answer: string | Array<string>;
  answerType: 'answer' | 'unorderedList' | 'orderedList';
  listHeader?: string;
};

type FaqData = {
  data: Array<FaqQuestion>;
};

type FaqSectionProps = {
  className?: string;
  faqData?: FaqData;
  questionHeadingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const FaqSection = ({ className, faqData, questionHeadingLevel = 'h2' }: FaqSectionProps) => {
  if (faqData && faqData.data.length < 1) {
    return null;
  }

  const standardAnswerFormat = (answer: string | Array<string>) => {
    return <S.FaqAnswer>{answer}</S.FaqAnswer>;
  };

  const listAnswerFormat = (question: FaqQuestion) => {
    const answerType = question.answerType;
    const ListElement = answerType === 'unorderedList' ? 'ul' : 'ol';

    return (
      <>
        {question.listHeader && <S.FaqAnswerListHeader>{question.listHeader}</S.FaqAnswerListHeader>}
        <S.FaqAnswerList as={ListElement} listStyle={ListElement}>
          {Array.isArray(question.answer) &&
            question.answer.length &&
            question.answer.map((answer, idx) => {
              return <S.FaqAnswerLi key={`answer-${idx}-${answer}`}>{answer}</S.FaqAnswerLi>;
            })}
        </S.FaqAnswerList>
      </>
    );
  };

  return (
    <>
      {faqData &&
        faqData.data.map((question) => {
          const answerType = question.answerType;

          return (
            <section className={className} key={`question-id-${question.question}`}>
              <S.FaqQuestion as={questionHeadingLevel}>{question.question}</S.FaqQuestion>
              {answerType === 'answer' && standardAnswerFormat(question.answer)}
              {(answerType === 'unorderedList' || answerType === 'orderedList') && listAnswerFormat(question)}
            </section>
          );
        })}
    </>
  );
};

export default FaqSection;
